import React, { useEffect, useState } from "react";
import axios, { baseUrl } from "../../config/axios";
import { Active, Inactive } from "../../shared/ActivaInactive";
import DeleteIcon from "@mui/icons-material/Delete";
import { CustomIconButton } from "../../shared/CustomIconButton";
import { CustomButton } from "../../shared/CustomButton";
import EditIcon from "@mui/icons-material/Edit";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import {
  Button,
  FormControl,
  Input,
  InputLabel,
  Pagination,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { TimeToLeave } from "@mui/icons-material";
import ReactQuill from "react-quill";
import MultiSearchAndSelect from "../../shared/MultiSearchAndSelect";

// import { Subscribable } from "react-query/types/core/subscribable";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const OfferManagement = () => {
  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const handleOpen = () => setOpen(true);

  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = React.useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);

  // add offer Data List start
  const [offerTypeAdd, setOfferTypeAdd] = useState("");
  const [offerTypeId, setOfferTypeId] = useState(null);
  // add offer Data List end

  // add offer category and product based start
  const [checked, setChecked] = useState("first");
  const [updatedata, setUpdatedata] = useState([]);
  const [validFrom, setValidFrom] = useState("");
  const [createDate, setCreateDate] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [offerId, setOfferID] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [productId, setProductId] = useState("");
  const [purchageUpTo, setPurchageUpTo] = useState("");
  const [discoutUpTo, setDiscoutUpTo] = useState("");
  const [offerTag, setOfferTag] = useState("");
  const [discount, setDiscount] = useState("");
  const [termCondition, setTermCondition] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [ProductList, setProductList] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [AllvariantData, setAllVariantData] = useState([]);
  const [searchValue, setSearchValue] = useState("")
  const [variantId, setVariantId] = useState("");
  const [title, setTitle] = useState("");
  const storeId = localStorage.getItem("store_id");
  const [ids, setIds] = useState(null);

  const [offerTypeData, setOfferTypeData] = useState([]);
  const [btnShow, setBtnShow] = useState("");
  // add offer category and product based end
  const [rowData, setRowData] = useState({});

  // add offer subscription based start
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [subscriptionId, setSubscriptionId] = useState("");
  const [subOfferId, setSubOfferId] = useState("");
  const [subValidFrom, setSubValidFrom] = useState("");
  const [subValidTo, setSubValidTo] = useState("");
  const [subCouponCode, setsubCouponCode] = useState("");
  const [subPurchaseUpto, setsubPurchaseUpto] = useState("");
  const [subDiscount, setSubDiscount] = useState("");
  const [subOfferTag, setSubOfferTag] = useState("");
  const [subTermsAndCondition, setSubTermsAndCondition] = useState("");
  const [discoutUpTo1, setDiscoutUpTo1] = useState("");
  const [subIds, setSubIds] = useState(null);
  const [subRowData, setSubRowData] = useState({});
  const [allOfferVarient, setAllOfferVarient] = useState([])

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
      [{ script: "sub" }, { script: "super" }],
      [{ direction: "rtl" }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ["link", "image", "video", "formula"],
      ["clean"], // remove formatting
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "script",
    "direction",
    "size",
    "color",
    "background",
    "font",
    "align",
    "link",
    "image",
    "video",
    "formula",
  ];

  const handleClose = () => {

    setValidFrom("");
    setCreateDate("");
    setCategoryId("");
    setOfferID("");
    setCouponCode("");
    setProductId("");
    setPurchageUpTo("");
    setOfferTag("");
    setDiscount("");
    setTermCondition("");
    setVariantId("");
    setAllOfferVarient([])

    setIds(null)
    offerDataList();
    setTitle("");
    setOpen(false);

  }

  const subscriptionDataList = () => {
    axios
      .get(
        `${baseUrl}api/admin/product-variants-subscription-list/?store_id=${storeId}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        console.log("subscription Data List===>", response?.data?.data);
        setSubscriptionData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    open1 && subscriptionDataList();
  }, [open1]);

  const subsciptionAdd = () => {
    const fd = new FormData();
    fd.append(
      "subcription_type_id",
      subscriptionId || subRowData?.subscription_type?.id
    );
    fd.append("offer_type_id", subOfferId || subRowData?.offer_type?.id);
    fd.append("valid_to", subValidTo);
    fd.append("valid_from", subValidFrom);
    fd.append("coupon_code", subCouponCode);
    fd.append("discount_percentage", subDiscount);
    fd.append("offer_tag", subOfferTag);
    fd.append("purchase_upto", subPurchaseUpto);
    fd.append("term_condition", subTermsAndCondition);
    fd.append("discount_upto", discoutUpTo1);
    fd.append("offer_id", subIds);


    subIds === null
      ? axios
        .post(
          `${baseUrl}api/admin/add-offer-api/?store_id=${storeId}`,
          fd,
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((res) => {
          if (res.data.response_code === 200) {
            toast.success(res.data.message);
            setSubscriptionId("");
            setSubOfferId("");
            setSubValidFrom("");
            setSubValidTo("");
            setsubCouponCode("");
            setsubPurchaseUpto("");
            setSubDiscount("");
            setSubOfferTag("");
            setSubIds(null);
            setSubTermsAndCondition("");
            setDiscoutUpTo1("");
            setAllOfferVarient([])
            handleClose1();
            offerDataList();
            setOfferID("")
          } else {
            toast.warn(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        })
      : axios
        .put(
          `${baseUrl}api/admin/offer-list-api/?store_id=${storeId}`,
          fd,
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((res) => {
          if (res.data.response_code === 200) {
            toast.success(res.data.message);
            setSubscriptionId("");
            setSubOfferId("");
            setSubValidFrom("");
            setSubValidTo("");
            setsubCouponCode("");
            setsubPurchaseUpto("");
            setSubDiscount("");
            setSubOfferTag("");
            setSubTermsAndCondition("");
            setSubIds(null);
            setDiscoutUpTo1("");
            setAllOfferVarient([])
            handleClose1();
            offerDataList();
            setOfferID()
          } else {
            toast.warn(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
  };

  // add offer subscription based end

  const PreviousData = () => {
    setPage(page - 1);
  };
  const nextData = () => {
    setPage(page + 1);
  };

  const offerDataList = () => {
    axios
      .get(
        `${baseUrl}api/admin/offer-list-api/?store_id=${storeId}&search=${searchQuery}&page=${page}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.data);
        console.log("data===>", response?.data?.data);
        setCurrentPage(response.data.current_page);
        setTotalPage(response.data.total_pages);
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
      });
  };

  useEffect(() => {
    offerDataList();
  }, [searchQuery]);

  const deleteData = (id) => {
    if (window.confirm("You want to sure delete this offer...!")) {
      axios
        .post(
          `${baseUrl}api/admin/delete-offer-api/?store_id=1`,
          { offer_id: id },
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((response) => {
          toast.success(response?.data?.message);
          offerDataList();
        })
        .catch((error) => {
          console.log("", error.response);
          console.log(error);
        });
    } else {
      console.log("");
    }
  };

  const goToProduct = (rows, rowBtn) => {
    console.log("event", rowBtn);
    setBtnShow(rowBtn);
    handleOpen();
    rows();
  };
  const goToSubscription = (rows, rowBtn) => {
    handleOpen1();
    setBtnShow(rowBtn);
    rows();
  };

  const handleRadioChange = (event) => {
    setChecked(event.target.value);
  };

  const CategoryList = (item) => {
    axios
      .post(
        `${baseUrl}api/admin/multivendor-show-main-category-list/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setCategoryList(response?.data?.main_category_data);
      })
      .catch((error) => {
        console.log("category error", error);
      });
  };
  useEffect(() => {
    CategoryList();
  }, []);

  // category and product based data add start
  const handleSubmit = (e) => {

    console.log(allOfferVarient, "pooooooooooooooooooooooooooooooooo")
    e.preventDefault();
    console.log("idssss==>", rowData?.main_category?.id);

    const AllOfferId = allOfferVarient?.map((i) => (i?.value))
    const fd = new FormData();
    fd.append("valid_to", createDate);
    fd.append("valid_from", validFrom);
    fd.append("offer_tag", offerTag);
    fd.append("offer_type_id", offerId || rowData?.offer_type?.id);
    fd.append("coupon_code", couponCode);
    fd.append("purchase_upto", purchageUpTo);
    fd.append(
      "main_category_id",
      categoryId
        ? categoryId
        : "" || rowData?.main_category?.id
          ? rowData?.main_category?.id
          : ""
    );
    fd.append("product_variant_id", variantId);
    fd.append("term_condition", termCondition);
    fd.append("discount_percentage", discount);
    fd.append("discount_upto", discoutUpTo);
    fd.append("offer_id", ids);
    fd.append("title", title);
    fd.append("combo_offer_variant", JSON.stringify(AllOfferId))
    ids === null
      ? axios
        .post(
          `${baseUrl}api/admin/add-offer-api/?store_id=${storeId}`,
          fd,
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((res) => {
          if (res.data.response_code === 200) {
            toast.success(res.data.message);
            setValidFrom("");
            setCreateDate("");
            setCategoryId("");
            setOfferID("");
            setCouponCode("");
            setProductId("");
            setPurchageUpTo("");
            setOfferTag("");
            setDiscount("");
            setTermCondition("");
            setVariantId("");
            setUpdatedata(res.data);
            handleClose();
            offerDataList();
            setTitle("");
            setAllOfferVarient([])
            setOfferID()
          } else {
            toast.warn(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        })
      : axios
        .put(
          `${baseUrl}api/admin/offer-list-api/?store_id=${storeId}`,
          fd,
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((res) => {
          if (res.data.response_code === 200) {
            toast.success(res.data.message);
            setValidFrom("");
            setCreateDate("");
            setCategoryId("");
            setOfferID("");
            setCouponCode("");
            setProductId("");
            setPurchageUpTo("");
            setOfferTag("");
            setDiscount("");
            setTermCondition("");
            setVariantId("");
            setUpdatedata(res.data);
            handleClose();
            offerDataList();
            setTitle("");
            setAllOfferVarient([])
            setOfferID()
          } else {
            toast.warn(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
  };
  // category and product based data add end

  const inventoryData = () => {
    axios
      .get(
        `${baseUrl}api/admin/multivendor-product-list-without-pagination-admin/?store_id=${storeId}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setProductList(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    inventoryData();
  }, []);

  const vairiantDataList = () => {
    axios
      .get(
        `${baseUrl}api/admin/product-variant-list/?store_id=${storeId}&product_id=${productId}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        console.log("Inventory Data List===>", response?.data?.data);
        setVariantData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    vairiantDataList();
  }, [productId]);




  const AllvairiantDataList = () => {
    axios
      .get(
        `${baseUrl}api/admin/product-variant-list-for-offer/?store_id=${storeId}&variant_id=${variantId}&search=${searchValue}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        console.log("All Inventory Data List===>", response?.data?.data);
        setAllVariantData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    AllvairiantDataList();
  }, [searchValue, variantId]);


  const offerTypeList = () => {
    axios
      .get(
        `${baseUrl}api/admin/offer-type/?store_id=${storeId}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        console.log("Inventory Data List===>", response?.data?.data);
        setOfferTypeData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    offerTypeList();
  }, []);

  const submitOfferType = () => {
    const fd = new FormData();
    fd.append("offer_type", offerTypeAdd);
    fd.append("offer_type_id", offerTypeId);
    // fd.append("store_id", storeId);

    offerTypeId === null
      ? axios
        .post(
          `${baseUrl}api/admin/offer-type/?store_id=${storeId}`,
          fd,
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((response) => {
          toast.success(response.data.message);
          setOfferTypeAdd("");
          setOfferTypeId(null);
          offerTypeList();
        })
        .catch((error) => {
          console.log("", error);
        })
      : axios
        .put(
          `${baseUrl}api/admin/offer-type/?store_id=${storeId}`,
          fd,
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((response) => {
          toast.success(response.data.message);
          setOfferTypeAdd("");
          setOfferTypeId(null);
          offerTypeList();
        })
        .catch((error) => {
          console.log("", error);
        });
  };

  const handleChange = (id) => {
    axios
      .post(
        `${baseUrl}api/admin/offer-enable-or-disable-api/?store_id=${storeId}`,
        {
          offer_id: id,
        },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response.data.message);
        offerDataList();
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  const deleteOfferType = (id) => {
    axios
      .delete(
        `${baseUrl}api/admin/offer-type/?store_id=${storeId}`,
        { offer_id: id },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response.data.message);
        offerTypeList();
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  const EditFunction = (row) => {
    setOfferTypeId(row?.id);
    setOfferTypeAdd(row?.offer_type);
  };

  const editFunctionality = (row) => {

    if (row?.product_variant) {
      setChecked("second")
      setProductId(row?.product_variant?.product)
      setVariantId(row?.product_variant?.id)
    }
    else {
      setChecked("first")
      setCategoryId(row?.main_category?.id)
    }
    setRowData(row);
    handleOpen();
    setIds(row?.id);
    setValidFrom(row?.valid_from?.slice(0, 10));
    setCreateDate(row?.create_date?.slice(0, 10));
    setCouponCode(row?.coupon_code);
    setPurchageUpTo(row?.purchase_upto);
    setDiscoutUpTo(row?.discount_upto);
    setOfferTag(row?.offer_tag);
    setDiscount(row?.discount);
    setTermCondition(row?.term_condition);
    setTitle(row?.title);
    setOfferID(row?.offer_type?.id)
    setAllOfferVarient(row?.combo_offer_variant?.map((i) => (({
      label: i?.product_variant_name,
      value: i?.id,
    }))))

  };

  const handleChange1 = (event, value) => {
    setPage(value);
  };


  const VarintAllList = AllvariantData?.map((i) => ({
    label: i?.product_variant_name,
    value: i?.id,
  }))

  return (
    <>
      <div className="flex flex-col">
        <div className="flex bg-gray-100 justify-between">
          <div className="p-2">
            <p className="text-xl text-black font-bold">Offers Management</p>
          </div>
          <div className="flex justify-between gap-x-2">
            <div>
              <Button
                variant="outlined"
                size="small"
                className="!mt-2 !p-1"
                onClick={handleOpen2}
              >
                Add Offer Type
              </Button>
            </div>
            <div>
              {/* <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <Button
                      variant="contained"
                      className="!m-2"
                      {...bindTrigger(popupState)}
                    >
                      Add Offer
                    </Button>
                    <Menu {...bindMenu(popupState)}>
                      <MenuItem
                        onClick={() =>
                          goToProduct(popupState?.close, "ON PRODUCT")
                        }
                      >
                        ON PRODUCT
                      </MenuItem>
                    </Menu>
                  </React.Fragment>
                )}
              </PopupState> */}
              <Button
                variant="outlined"
                size="small"
                className="!mt-2 !p-1"
                onClick={() => handleOpen()}
              >
                Add Offer
              </Button>
            </div>
          </div>

          {/* category and product based data add start */}
          {/* <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="!border-0 !rounded-md !bg-slate-100 !bg-opacity-90"
            >
              <Typography id="modal-modal-title">
                <div
                  className="!text-center font-bold underline underline-offset-4"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {ids === null ? " Add Offer" : " Update Offer"}
                </div>
              </Typography>
              <Typography id="modal-modal-description" sx={{}}>
                <div className="item-center form h-[400px] w-full overflow-auto">
                  <div style={{ marginTop: "2rem" }}>
                    <div>
                      <input
                        style={{ marginLeft: "1vw" }}
                        type="radio"
                        name="category"
                        value="first"
                        checked={checked === "first"}
                        onChange={handleRadioChange}
                      />
                      Category
                      <input
                        style={{ marginLeft: "4vw" }}
                        type="radio"
                        name="category"
                        value="second"
                        checked={checked === "second"}
                        onChange={handleRadioChange}
                      />
                      Product Variant
                    </div>
                  </div>
                  <div className="flex justify-between w-full">
                    <div className="w-[48%]">
                      {checked === "first" ? (
                        <div className="mb-3 !w-[!400px]">
                          <InputLabel
                            className="!mt-1 !text-gray-700"
                            style={{ fontFamily: "'Poppins', sans-serif" }}
                          >
                            <div className="text-sm my-1">Category :</div>
                          </InputLabel>
                          <FormControl fullWidth>
                            <Select
                              labelId="demo-simple-select-label"
                              size="small"
                              name="return_status"
                              id="category_id"
                              className="!w-[!400px]"
                              value={
                                categoryId || rowData?.main_category?.id || ""
                              }
                              onChange={(e) => setCategoryId(e.target.value)}
                            >
                              {categoryList?.map((elem) => (
                                <MenuItem value={elem?.id}>
                                  {elem?.category}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      ) : null}

                      {checked === "second" ? (
                        <div className="mb-3">
                          <div className="mt-2">Select Product :</div>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              className="mt-1"
                              onChange={(e) => setProductId(e.target.value)}
                              name="productId"
                            >
                              {ProductList?.map((elem) => (
                                <MenuItem value={elem?.id}>
                                  {elem?.title}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <div className="mt-2">Select Product Variant :</div>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              className="mt-1"
                              // value={productId }
                              onChange={(event) =>
                                setVariantId(event.target.value)
                              }
                              name="variantId"
                            >
                              {variantData?.map((elem) => (
                                <MenuItem value={elem?.id}>
                                  {elem?.product_variant_name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      ) : null}

                      <div className="mt-3">
                        <div
                          style={{ fontSize: "2vh" }}
                          htmlFor="Select Date"
                          className="form-label"
                        >
                          Create Date :
                        </div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          type="date"
                          className="w-full mt-1"
                          placeholder="Enter Coupon Code"
                          value={createDate}
                          onChange={(event) =>
                            setCreateDate(event.target.value)
                          }
                        />
                      </div>
                      <div className="mb-3">
                        <div className="text-sm mt-2">Coupon Code : </div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          className="w-full mt-1"
                          placeholder="Enter Coupon Code"
                          value={couponCode}
                          onChange={(e) => setCouponCode(e.target.value)}
                        />
                      </div>
                      <div className="mt-2">
                        <div className="text-sm">Discount %</div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          className="w-full"
                          placeholder="Enter Discount %"
                          value={discount}
                          onChange={(e) => setDiscount(e.target.value)}
                        />
                      </div>
                      <div className="mt-2">
                        <label
                          style={{ fontSize: "2vh" }}
                          htmlFor="description"
                          className="form-label"
                        >
                          Title :
                        </label>
                        <textarea
                          type="text"
                          className="form-control border !bg-transparent border-black w-full rounded p-1 py-2"
                          id="description"
                          rows={1}
                          placeholder="Enter offer tag"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="w-[48%]">
                      <div className="mt-2">
                        <label
                          style={{ fontSize: "2vh" }}
                          htmlFor="code"
                          className="form-label"
                        >
                          Offer Type
                        </label>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            size="small"
                            name="return_status"
                            className="!w-[!400px]"
                            value={offerId || rowData?.offer_type?.id || ""}
                            onChange={(e) => setOfferID(e.target.value)}
                          >
                            {offerTypeData?.map((item) => (
                              <MenuItem value={item?.id}>
                                {item?.offer_type}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>


                      <MultiSearchAndSelect
                        options={VarintAllList}
                        value={allOfferVarient}
                        className="!w-full"
                        placeholder="Select Combo Product"
                        label="Combo Product*"
                        name="recipient_id_list"
                        setSearchValue={setSearchValue}
                        setValue={(value) => setAllOfferVarient(value)}
                      // formik={formik}
                      />
                      <div className="mt-2">
                        <div
                          style={{ fontSize: "2vh" }}
                          htmlFor="Select Date"
                          className="form-label"
                        >
                          Valid From
                        </div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          type="date"
                          className="w-full mt-1"
                          placeholder="Enter Purchase Upto"
                          value={validFrom}
                          onChange={(event) => setValidFrom(event.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="text-sm mt-2">Purchase Upto : </div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          className="w-full mt-1"
                          placeholder="Enter Purchase Upto"
                          value={purchageUpTo}
                          onChange={(e) => setPurchageUpTo(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="text-sm mt-2">Discount Upto : </div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          className="w-full mt-1"
                          placeholder="Enter Discount Upto"
                          value={discoutUpTo}
                          onChange={(e) => setDiscoutUpTo(e.target.value)}
                        />
                      </div>
                      <div>
                        <label
                          style={{ fontSize: "2vh" }}
                          htmlFor="description"
                          className="form-label"
                        >
                          Offer Tag :
                        </label>
                        <textarea
                          type="text"
                          className="form-control !bg-transparent border border-black w-full rounded p-1 py-2"
                          id="description"
                          rows={1}
                          placeholder="Enter offer tag"
                          value={offerTag}
                          onChange={(e) => setOfferTag(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="mt-2">Terms Condition</div>
                    <ReactQuill
                      className="w-full bg-gray-100 mt-1 text-lg !bg-transparent font-semibold border border-gray-500"
                      value={termCondition}
                      onChange={setTermCondition}
                    ></ReactQuill>
                  </div>
                  <Button
                    onClick={handleClose}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={handleSubmit}
                  >
                    {ids === null ? "Add Offers" : "UPDATE Offers"}
                  </Button>
                </div>
              </Typography>
            </Box>
          </Modal> */}

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="border-0 rounded-md bg-slate-100 bg-opacity-90 p-6 max-h-[90vh] overflow-auto"
            >
              <Typography id="modal-modal-title">
                <div className="text-center font-bold underline underline-offset-4 text-lg" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  {ids === null ? "Add Offer" : "Update Offer"}
                </div>
              </Typography>

              <div className="flex flex-col gap-4 mt-4">
                {/* Radio Selection */}
                <div className="flex gap-8 items-center">
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="category"
                      value="first"
                      checked={checked === "first"}
                      onChange={handleRadioChange}
                    />
                    Category
                  </label>
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="category"
                      value="second"
                      checked={checked === "second"}
                      onChange={handleRadioChange}
                    />
                    Product Variant
                  </label>
                </div>

                <div className="flex flex-col lg:flex-row gap-6">
                  {/* Left Column */}
                  <div className="flex-1 flex flex-col gap-4">
                    {checked === "first" && (
                      <div>
                        <InputLabel className="text-gray-700 text-sm mb-1">Category :</InputLabel>
                        <FormControl fullWidth size="small">
                          <Select
                            value={categoryId || rowData?.main_category?.id || ""}
                            onChange={(e) => setCategoryId(e.target.value)}
                          >
                            {categoryList?.map((elem) => (
                              <MenuItem key={elem?.id} value={elem?.id}>
                                {elem?.category}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    )}

                    {checked === "second" && (
                      <div className="flex flex-col gap-2">
                        <div>
                          <InputLabel className="text-sm mb-1">Select Product :</InputLabel>
                          <FormControl fullWidth size="small">
                            <Select onChange={(e) => setProductId(e.target.value)} value={productId} name="productId">
                              {ProductList?.map((elem) => (
                                <MenuItem key={elem?.id} value={elem?.id}>
                                  {elem?.title}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                        <div>
                          <InputLabel className="text-sm mb-1">Select Product Variant :</InputLabel>
                          <FormControl fullWidth size="small">
                            <Select onChange={(e) => setVariantId(e.target.value)} value={variantId} name="variantId">
                              {variantData?.map((elem) => (
                                <MenuItem key={elem?.id} value={elem?.id}>
                                  {elem?.product_variant_name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    )}
                    <div>
                      <InputLabel className="text-sm mb-1">Valid Form :</InputLabel>
                      <TextField

                        type="date"
                        size="small"
                        fullWidth
                        value={validFrom}
                        onChange={(e) => setValidFrom(e.target.value)}
                      />
                    </div>


                    <div>
                      <InputLabel className="text-sm mb-1">Valid To :</InputLabel>
                      <TextField
                        type="date"
                        size="small"
                        fullWidth
                        value={createDate}
                        onChange={(e) => setCreateDate(e.target.value)}
                      />
                    </div>

                    <TextField
                      label="Coupon Code"
                      size="small"
                      fullWidth
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                    />
                    <TextField
                      label="Discount %"
                      size="small"
                      fullWidth
                      value={discount}
                      onChange={(e) => setDiscount(e.target.value)}
                    />
                    <div>
                      <InputLabel className="text-sm mb-1">Title :</InputLabel>
                      <textarea
                        className="w-full border border-black rounded p-2"
                        rows={1}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="flex-1 flex flex-col gap-4">
                    <div>
                      <InputLabel className="text-sm mb-1">Offer Type :</InputLabel>
                      <FormControl fullWidth size="small">
                        <Select
                          value={offerId}
                          onChange={(e) => setOfferID(e.target.value)}
                        >
                          {offerTypeData?.map((item) => (
                            <MenuItem key={item?.id} value={item?.id}>
                              {item?.offer_type}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <MultiSearchAndSelect
                      options={VarintAllList}
                      value={allOfferVarient}
                      setValue={setAllOfferVarient}
                      setSearchValue={setSearchValue}
                      className="w-full"
                      placeholder="Select Combo Product"
                      label="Combo Product*"
                      name="recipient_id_list"
                    />


                    <TextField
                      label="Purchase Upto"
                      size="small"
                      fullWidth
                      value={purchageUpTo}
                      onChange={(e) => setPurchageUpTo(e.target.value)}
                    />
                    <TextField
                      label="Discount Upto"
                      size="small"
                      fullWidth
                      value={discoutUpTo}
                      onChange={(e) => setDiscoutUpTo(e.target.value)}
                    />
                    <div>
                      <InputLabel className="text-sm mb-1">Offer Tag :</InputLabel>
                      <textarea
                        className="w-full border border-black rounded p-2"
                        rows={1}
                        value={offerTag}
                        onChange={(e) => setOfferTag(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* Terms & Conditions */}
                <div className="mt-4">
                  <InputLabel className="text-sm mb-1">Terms & Conditions :</InputLabel>
                  <ReactQuill
                    className="w-full bg-gray-100 mt-1 border border-gray-500"
                    value={termCondition}
                    onChange={setTermCondition}
                    modules={modules}
                    formats={formats}
                    theme="snow"
                  />
                </div>

                {/* Buttons */}
                <div className="flex justify-between mt-4">
                  <Button onClick={handleClose} variant="contained" color="warning">
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleSubmit}
                  >
                    {ids === null ? "Add Offers" : "UPDATE Offers"}
                  </Button>
                </div>
              </div>
            </Box>
          </Modal>

          {/* category and product based data add end */}

          {/* subscription based data add start */}
          <Modal
            open={open1}
            onClose={handleClose1}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="!border-0 !rounded-xl">
              <Typography id="modal-modal-title">
                <div
                  className="!text-center underline underline-offset-4"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {subIds === null
                    ? " Add Offer (subscription based)"
                    : " Update Offer (subscription based)"}
                </div>
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <div className="item-center form h-[400px] w-full">
                  <div className="flex justify-between w-full">
                    <div className="w-[48%]">
                      <div className="mb-3">
                        <div className="">Select Subscription :</div>
                        <FormControl fullWidth>
                          <Select
                            size="small"
                            className="mt-1"
                            value={subscriptionId || subRowData?.offer_type?.id}
                            onChange={(e) => setSubscriptionId(e.target.value)}
                            name="productId"
                          >
                            {subscriptionData?.map((elem) => (
                              <MenuItem value={elem?.id}>
                                {elem?.subscription_name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>












                      {/*

                      <MultiSearchAndSelect
                        options={VarintAllList}
                        className="!w-full"
                        placeholder="Select Recipients"
                        label="Recipients*"
                        name="recipient_id_list"
                        setSearchValue={setSearchValue}
                        setValue={(value) => setAllOfferVarient(value)}
                      // formik={formik}
                      /> */}

                      <div className="mt-3">
                        <div
                          style={{ fontSize: "2vh" }}
                          htmlFor="Select Date"
                          className="form-label"
                        >
                          Valid From Date :
                        </div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          type="date"
                          className="w-full mt-1"
                          placeholder="Enter Coupon Code"
                          value={subValidFrom}
                          onChange={(event) =>
                            setSubValidFrom(event.target.value)
                          }
                        />
                      </div>
                      <div className="mb-3">
                        <div className="text-sm mt-2">Coupon Code : </div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          className="w-full mt-1"
                          placeholder="Enter Coupon Code"
                          value={subCouponCode}
                          onChange={(e) => setsubCouponCode(e.target.value)}
                        />
                      </div>
                      <div className="mt-2">
                        <div className="text-sm">Discount %</div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          className="w-full"
                          placeholder="Enter Discount %"
                          value={subDiscount}
                          onChange={(e) => setSubDiscount(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          style={{ fontSize: "2vh" }}
                          htmlFor="description"
                          className="form-label"
                        >
                          Terms Condition
                        </label>
                        <textarea
                          type="text"
                          className="form-control border border-black w-full rounded p-1 py-2"
                          id="description"
                          rows={1}
                          placeholder="Enter Terms and condition"
                          value={subTermsAndCondition}
                          onChange={(e) =>
                            setSubTermsAndCondition(e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="w-[48%]">
                      <div className="mt-2">
                        <label
                          style={{ fontSize: "2vh" }}
                          htmlFor="code"
                          className="form-label"
                        >
                          Offer Type
                        </label>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            size="small"
                            name="return_status"
                            className="!w-[!400px]"
                            value={
                              subOfferId ||
                              subRowData?.subscription_type?.id ||
                              ""
                            }
                            onChange={(e) => setSubOfferId(e.target.value)}
                          >
                            {offerTypeData?.map((item) => (
                              <MenuItem value={item?.id}>
                                {item?.offer_type}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div className="mt-2">
                        <div
                          style={{ fontSize: "2vh" }}
                          htmlFor="Select Date"
                          className="form-label"
                        >
                          Valid To (Date)
                        </div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          type="date"
                          className="w-full mt-1"
                          placeholder="Enter Purchase Upto"
                          value={subValidTo}
                          onChange={(event) =>
                            setSubValidTo(event.target.value)
                          }
                        />
                      </div>
                      <div className="mb-3">
                        <div className="text-sm mt-2">Purchase Upto : </div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          className="w-full mt-1"
                          placeholder="Enter Purchase Upto"
                          value={subPurchaseUpto}
                          onChange={(e) => setsubPurchaseUpto(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="text-sm mt-2">Discount Upto : </div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          className="w-full mt-1"
                          placeholder="Enter Purchase Upto"
                          value={discoutUpTo1}
                          onChange={(e) => setDiscoutUpTo1(e.target.value)}
                        />
                      </div>

                      {/* setDiscoutUpTo1 */}
                      <div>
                        <label
                          style={{ fontSize: "2vh" }}
                          htmlFor="description"
                          className="form-label"
                        >
                          Offer Tag :
                        </label>
                        <textarea
                          type="text"
                          className="form-control border border-black w-full rounded p-1 py-2"
                          id="description"
                          rows={1}
                          placeholder="Enter offer tag"
                          value={subOfferTag}
                          onChange={(e) => setSubOfferTag(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <Button
                    onClick={handleClose1}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={subsciptionAdd}
                  >
                    {subIds === null ? "Add Offers" : "Update Offers"}
                  </Button>
                </div>
              </Typography>
            </Box>
          </Modal>
          {/* subscription based data add end */}
          <Modal
            open={open2}
            onClose={handleClose2}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style1}
              className="!border-0 !rounded-md !bg-slate-100 !bg-opacity-90"
            >
              <Typography id="modal-modal-title">
                <div
                  className="!text-center underline font-bold text-xl underline-offset-4"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Add Offer Type List
                </div>
                <div
                  className="relative bottom-12 px-2 bg-slate-300 text-black font-bold cursor-pointer rounded-sm left-5 float-right"
                  onClick={handleClose2}
                >
                  x
                </div>
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <div className="item-center form h-[400px] w-full ">
                  <div>
                    <TableContainer
                      component={Paper}
                      sx={{ maxHeight: "80vh" }}
                      className="!bg-slate-100 !bg-opacity-90"
                    >
                      <Table
                        stickyHeader
                        aria-label="sticky table"
                        size="small"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell
                              style={{
                                borderRight: "1px solid #D0D0D0",
                                fontFamily: "'Poppins', sans-serif",
                              }}
                              className="!text-center  !text-gray-800 !font-bold"
                            >
                              SR NO.
                            </TableCell>
                            <TableCell
                              style={{
                                borderRight: "1px solid #D0D0D0",
                                fontFamily: "'Poppins', sans-serif",
                              }}
                              className="!text-center  !text-gray-800 !font-bold"
                            >
                              OFFER TYPE
                            </TableCell>
                            <TableCell
                              style={{
                                fontFamily: "'Poppins', sans-serif",
                              }}
                              className="!text-center  !text-gray-800 !font-bold"
                            >
                              ACTION
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {offerTypeData?.map((row, ind) => (
                            <TableRow
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                className="!text-center !text-[12px]"
                                style={{
                                  borderRight: "1px solid #D0D0D0",
                                  fontFamily: "'Poppins', sans-serif",
                                }}
                              >
                                {ind + 1}
                              </TableCell>
                              <TableCell
                                className="!text-center !text-[12px]"
                                style={{
                                  borderRight: "1px solid #D0D0D0",
                                  fontFamily: "'Poppins', sans-serif",
                                }}
                              >
                                {row?.offer_type}
                              </TableCell>
                              <TableCell
                                className="!text-center !text-[12px]"
                                style={{
                                  fontFamily: "'Poppins', sans-serif",
                                }}
                              >
                                {/* <DeleteIcon className="!text-xl !text-red-600 !cursor-pointer"
                                onClick={()=>deleteOfferType(row?.id)} /> */}
                                <EditIcon
                                  className="!text-xl !cursor-pointer !text-green-600"
                                  onClick={() => EditFunction(row)}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                  <div className="flex w-full gap-x-2">
                    <div className="">
                      <TextField
                        id="outlined-basic"
                        size="small"
                        className="w-full !mt-3"
                        placeholder="Enter Offer Type Name"
                        value={offerTypeAdd}
                        onChange={(e) => setOfferTypeAdd(e.target.value)}
                      />
                    </div>
                    <div className="">
                      <Button
                        variant="contained"
                        type="submit"
                        color="success"
                        className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                        onClick={submitOfferType}
                      >
                        {offerTypeId === null ? "Add" : "UPDATE"}
                      </Button>
                    </div>
                  </div>
                </div>
              </Typography>
            </Box>
          </Modal>
        </div>

        <div className="flex flex-col my-4 rounded-lg shadow-md bg-white border border-gray-200">
          {/* Search Header */}
          <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-b border-gray-200 rounded-t-lg">
            <input
              type="text"
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
              placeholder="Search..."
              className="w-72 px-3 py-2 border border-gray-400 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>

          {/* Table */}
          <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
            <Table stickyHeader aria-label="coupons table" size="small">
              <TableHead>
                <TableRow>
                  {[
                    "SR NO.",
                    "CREATE DATE",
                    "VALID FROM",
                    "VALID TO",
                    "PRODUCT VARIANT",
                    "CATEGORY",
                    "CHANGE STATUS",
                    "TYPE",
                    "COUPON CODE",
                    "DISCOUNT %",
                    "DISCOUNT UPTO",
                    "PURCHASE UPTO",
                    "EDIT",
                  ].map((head, idx) => (
                    <TableCell
                      key={idx}
                      align="center"
                      className="text-xs font-semibold text-gray-700 bg-gray-100 border-r border-gray-200"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {data?.map((row, ind) => (
                  <TableRow
                    key={row?.id || ind}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      {ind + 1}
                    </TableCell>
                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      {row?.create_date ? row?.create_date.slice(0, 10) : "--"}
                    </TableCell>
                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      {row?.valid_from ? row?.valid_from.slice(0, 10) : "--"}
                    </TableCell>
                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      {row?.valid_to ? row?.valid_to.slice(0, 10) : "--"}
                    </TableCell>
                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      {row?.product_variant?.product_variant_name || "--"}
                    </TableCell>
                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      {row?.main_category?.category || "--"}
                    </TableCell>
                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      <Switch

                        checked={row.active}
                        onChange={() => handleChange(row?.id)}
                        color="success" // green when active
                        size="small"
                      />
                    </TableCell>

                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      {row?.offer_type?.offer_type || "--"}
                    </TableCell>
                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      {row?.coupon_code || "--"}
                    </TableCell>
                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      {row?.discount || "--"}
                    </TableCell>
                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      {row?.discount_upto || "--"}
                    </TableCell>
                    <TableCell align="center" className="text-xs text-gray-700 border-r">
                      {row?.purchase_upto || "--"}
                    </TableCell>
                    <TableCell align="center" className="text-xs text-gray-700">
                      <CustomIconButton>
                        <DeleteIcon
                          className="text-red-500 cursor-pointer hover:text-red-700"
                          onClick={() => deleteData(row?.id)}
                        />
                        <BorderColorIcon
                          className="text-green-500 cursor-pointer hover:text-green-700"
                          onClick={() => editFunctionality(row)}
                        />
                      </CustomIconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            {/* Pagination */}

          </TableContainer>
          {totalPage !== 0 && (
            <div className="flex justify-center border-t border-gray-200 py-3 bg-gray-50">
              <Pagination
                page={currentPage}
                size="small"
                count={totalPage}
                variant="outlined"
                color="primary"
                onChange={handleChange1}
              />
            </div>
          )}
        </div>

      </div>
    </>
  );
};

export default OfferManagement;
